




























































































































import Vue from 'vue'
import { SetEmployeePasswordPayload, ChangeEmployeePasswordPayload } from '@/types/payload'
import { CompanyEmployee } from '@/model/company/CompanyEmployee'
import { CurrentUser } from '@/model/CurrentUser'
import { SET_EMPLOYEE_PASSWORD, CHANGE_EMPLOYEE_PASSWORD } from '@/store/action-types'
import { ResponseBase } from '@/types/service-response'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import NumberField from '@/components/NumberField.vue'

interface ComponentData {
  password: string
  repeatPassword: string
  checkbox: boolean
  characters: boolean
  smallLetter: boolean
  capitalLetter: boolean
  number: boolean
  repeatPasswordValid: boolean
  showSnackbar: boolean
  showErrorSnackbar: boolean
  showSuccessSnackbar: boolean
  setPasswordRules: Array<(v: string) => string | boolean>
  setRepeatPasswordRules: Array<(v: string) => string | boolean>
  menu1: boolean
  menu2: boolean
  dateFromIso: string | null
  dateFromFormatted: string | null
  dateToIso: string | null
  dateToFormatted: string | null
  dateRules: Function[]
  anmeldungen: number
}

export default Vue.extend({
  name: 'Password',

  components: {
    NumberField
  },

  props: {
    currentUser: {
      type: Object as () => CurrentUser
    },
    employeeItem: {
      type: Object as () => CompanyEmployee
    },
  },

  data (): ComponentData {
    return {
      password: '',
      repeatPassword: '',
      checkbox: false,
      characters: false,
      smallLetter: false,
      capitalLetter: false,
      number: false,
      repeatPasswordValid: false,
      setPasswordRules: [
        v => !!v ,
        //@ts-ignore
        v => this.hasCharacters(v),
        //@ts-ignore
        v => this.hasLowerCase(v),
        //@ts-ignore
        v => this.hasUpperCase(v),
        //@ts-ignore
        v => this.hasNumber(v) 
      ],
      setRepeatPasswordRules: [
        v => !!v ,
        //@ts-ignore
        v => this.comparePassword(v)
      ],
      showSnackbar: false,
      showErrorSnackbar: false,
      showSuccessSnackbar: false,
      menu1: false,
      menu2: false,
      dateFromIso: null,
      dateFromFormatted: null,
      dateToIso: null,
      dateToFormatted: null,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },
        (value: string) => {
          return !!value
        },
        () => {
          //@ts-ignore
          return this.isDatesValid
        }
      ],
      anmeldungen: 0,
    }
  },

  watch: {
    password(newVal: string): void {
      if(this.hasCharacters(newVal)){
        this.characters = true
      } else {
        this.characters = false
      }
      if(this.hasLowerCase(newVal)){
        this.smallLetter = true
      } else {
        this.smallLetter = false
      }
      if(this.hasUpperCase(newVal)){
        this.capitalLetter = true
      } else {
        this.capitalLetter = false
      }
      if(this.hasNumber(newVal)){
        this.number = true
      } else {
        this.number = false
      }
      if(newVal === this.repeatPassword){
        this.repeatPasswordValid = true
      } else {
        this.repeatPasswordValid = false
      }
    },
    repeatPassword(newVal: string): void {
      if(newVal === this.password){
        this.repeatPasswordValid = true
      } else {
        this.repeatPasswordValid = false
      }
    },
    currentUser(newVal: CurrentUser): void {
      if(newVal) {
        const form: any = this.$refs['form']
        form.reset()
        this.checkbox = false
      }
    },
    employeeItem(newVal: CompanyEmployee): void {
      if(newVal) {
        const form: any = this.$refs['form']
        form.reset()
        this.checkbox = false
      }
    },
    dateFromFormatted (newVal: string | null): void {
      if (newVal) {
        this.dateFromIso = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : null
      } else {
        this.dateFromIso = null
      }
    },
    dateToFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateToIso = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : null
      } else {
        this.dateToIso = null
      }
    },
  },

  computed: {
    comparePasswordValid(): boolean {
      if(this.repeatPassword && this.repeatPassword.length > 0 && this.repeatPasswordValid) {
        return true
      } else {
        return false
      }
    },
    comparePasswordInvalid(): boolean {
      if(this.repeatPassword && this.repeatPassword.length > 0 && !this.repeatPasswordValid) {
        return true
      } else {
        return false
      }
    },
    canChangePassword(): boolean {
      if(this.employeeItem || this.currentUser.changePassword){
        return true
      } else {
        return false
      }
    },
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isDatesValid (): boolean {
      if(this.dateFromIso && moment(this.dateFromIso, 'YYYY-MM-DD').isValid() && this.dateToIso && moment(this.dateToIso, 'YYYY-MM-DD').isValid()) {
        return this.dateToIso && moment(this.dateToIso, 'YYYY-MM-DD').isBefore(moment(this.dateFromIso, 'YYYY-MM-DD')) ? false : true

      } else {
        return true
      }
    }
  },

  methods: {
    hasCharacters(str: string): boolean {
      if(str && str.length >= 8) {
        return true
      } else {
        return false
      }
    },

    hasLowerCase(str: string): boolean {
      if(str){
        return (/[a-z]/.test(str))
      } else {
        return false
      }
    },

    hasUpperCase(str: string): boolean {
      if(str){
        return (/[A-Z]/.test(str))
      } else {
        return false
      }
    },

    hasNumber(str: string): boolean {
      if(str){
        return (/[0-9]/.test(str))
      } else {
        return false
      }
    },

    comparePassword(str: string): boolean {
      if(str === this.password) {
        return true
      } else {
        return false
      }
    },

    onFieldFromChange (date: string): void {
      this.dateFromFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurFromDate (): void {
      this.dateFromFormatted = this.dateFromIso && moment(this.dateFromIso).isValid() ? moment(this.dateFromIso).format('DD.MM.YYYY') : null
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onFieldToChange (date: string): void {
      this.dateToFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurToDate (): void {
      this.dateToFormatted = this.dateToIso && moment(this.dateToIso).isValid() ? moment(this.dateToIso).format('DD.MM.YYYY') : null
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onAnmeldungenChange (): void {
      if(this.anmeldungen == null || this.anmeldungen < 0) {
        this.anmeldungen = 0
      }
    },


    async setEmployeePassword(): Promise<void>{
      const payload: SetEmployeePasswordPayload = {
        password: this.password,
        changePassword: this.checkbox,
        shortName: this.employeeItem.shortName,
        dateFrom: this.dateFromFormatted!,
        dateTo: this.dateToFormatted!,
        anmeldungen: this.anmeldungen
        }
      try {
        await this.$store.dispatch(SET_EMPLOYEE_PASSWORD, payload)
        this.showSuccessSnackbar = true
        const form: any = this.$refs['form']
        form.resetValidation()
        this.password = ''
        this.repeatPassword = ''
        this.checkbox = false
      } catch(e) {
        this.showErrorSnackbar = true
      }
    },

    async changeEmployeePassword(): Promise<void>{
      const payload: ChangeEmployeePasswordPayload = {
        password: this.password,
        id: this.currentUser.id,
        initials: this.currentUser.initials,
        dateFrom: this.dateFromFormatted!,
        dateTo: this.dateToFormatted!,
        anmeldungen: this.anmeldungen
        }
      try {
        const response: ResponseBase = await this.$store.dispatch(CHANGE_EMPLOYEE_PASSWORD, payload)
        if(response && !response.IsError) {
          this.showSuccessSnackbar = true
          const form: any = this.$refs['form']
          form.resetValidation()
          this.password = ''
          this.repeatPassword = ''
          this.checkbox = false
        } else {
          this.showErrorSnackbar = true
        }
      } catch(e) {
        this.showErrorSnackbar = true
      }
    },

    onSaveButtonClick(): void {
      const form: any = this.$refs['form']
      if(form.validate()) {
        if(this.employeeItem){
          this.setEmployeePassword()
        }
        if(this.currentUser){
          this.changeEmployeePassword()
        } 
      } else {
        this.showSnackbar = true
      }
    }
  },

  mounted (): void {
    this.dateFromIso = this.employeeItem && this.employeeItem.passwordFrom ? this.employeeItem.passwordFrom : null
    this.dateFromFormatted = this.dateFromIso ? moment(this.dateFromIso).format('DD.MM.YYYY') : null

    this.dateToIso = this.employeeItem && this.employeeItem.passwordTo ? this.employeeItem.passwordTo : null
    this.dateToFormatted = this.dateToIso ? moment(this.dateToIso).format('DD.MM.YYYY') : null

    this.anmeldungen = this.employeeItem.anmeldungen ? this.employeeItem.anmeldungen : 0

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 100)
  }

})
